import React, { useEffect, useState } from "react";

import Main from "../layout/Main"
const NoAccess = () => {
  return <Main>You Dont's Have Permission</Main>;
};
export default NoAccess;
